import React from 'react';
import { ShieldIcon, MessageCircleIcon, CheckIcon, BugOffIcon, LeafIcon, ArrowRightIcon, GiftIcon, SparklesIcon, MonitorSmartphoneIcon } from 'lucide-react';
export function BonusStack() {
  return <section className="bg-cream py-12 md:py-16 px-5" data-id="element-14">
      <div className="max-w-[1100px] mx-auto" data-id="element-15">
        {/* Section Header */}
        <p className="font-sans text-sm font-semibold uppercase tracking-widest text-burnt text-center mb-3" data-id="element-16">
          The Ultimate Protection Bundle
        </p>
        <h2 className="font-serif text-forest text-3xl md:text-4xl font-bold text-center mb-3 leading-tight" data-id="element-17">
          Wait — You Also Get These{' '}
          <span className="text-burnt" data-id="element-18">FREE Bonuses</span>
        </h2>
        <p className="font-sans text-gray-500 text-center mb-10 max-w-xl mx-auto" data-id="element-19">
          Order today and unlock two exclusive bonuses that supercharge your
          garden protection.
        </p>

        {/* BONUS CARDS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {/* CARD A: Pest-Proof Perimeter */}
          <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] overflow-hidden border-2 border-burnt/20 relative" data-id="element-21">
            {/* Top Banner */}
            <div className="bg-gradient-to-r from-burnt to-burnt-dark px-6 py-3 flex items-center justify-between" data-id="element-22">
              <div className="flex items-center gap-2" data-id="element-23">
                <GiftIcon className="w-4 h-4 text-white" data-id="element-24" />
                <span className="text-white text-xs font-bold uppercase tracking-wider font-sans" data-id="element-25">
                  Free Bonus #1
                </span>
              </div>
              <div className="bg-white text-burnt text-xs font-black uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-26">
                100% FREE
              </div>
            </div>

            <div className="p-6 md:p-8" data-id="element-27">
              {/* Product Image with Digital Edition seal */}
              <div className="relative w-56 sm:w-48 md:w-40 mx-auto mb-5" data-id="element-28">
                <div className="absolute -top-2 -right-2 z-20 bg-burnt text-white rounded-full w-14 h-14 flex flex-col items-center justify-center shadow-lg border-2 border-white transform rotate-12" data-id="element-29">
                  <MonitorSmartphoneIcon className="w-3 h-3 mb-0.5" data-id="element-30" />
                  <span className="text-[7px] font-bold uppercase leading-tight text-center font-sans" data-id="element-31">
                    Digital
                    <br data-id="element-32" />
                    Edition
                  </span>
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/9H36JZGpgxJhD7xo85HF3L/c04bc8f2-2f60-4949-8cac-032a924546b9.png" alt="The Pest-Proof Perimeter — Organic Shield" className="w-full h-auto rounded-lg shadow-md" data-id="element-33" />
              </div>

              <h3 className="font-serif text-forest text-xl md:text-2xl font-bold mb-2" data-id="element-34">
                The Pest-Proof Perimeter: Organic Shield
              </h3>
              <p className="font-sans text-gray-500 text-sm leading-relaxed mb-5" data-id="element-35">
                How to stop 95% of garden pests using kitchen staples — no toxic
                chemicals required.
              </p>

              {/* Price — more prominent */}
              <div className="flex items-center gap-3 mb-5" data-id="element-36">
                <span className="font-sans text-gray-400 text-base line-through" data-id="element-37">
                  $34.00
                </span>
                <span className="bg-forest text-white text-sm font-black uppercase px-4 py-1.5 rounded-full tracking-wide flex items-center gap-1.5" data-id="element-38">
                  <SparklesIcon className="w-3.5 h-3.5" data-id="element-39" />
                  FREE TODAY
                </span>
              </div>

              <ul className="space-y-2.5" data-id="element-40">
                <li className="flex items-start gap-2.5" data-id="element-41">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-42" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-43">
                    The 3-Ingredient "Magic" Spray (kitchen ingredients)
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-44">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-45" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-46">
                    The Cinnamon Ant-Shield technique
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-47">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-48" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-49">
                    Stop slugs and snails with the "Eggshell Trench"
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-50">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-51" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-52">
                    Safe for pets, kids, and pollinators
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* CARD B: Private Garden Mentor */}
          <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] overflow-hidden border-2 border-forest/20 relative" data-id="element-53">
            {/* Top Banner */}
            <div className="bg-gradient-to-r from-forest to-forest-dark px-6 py-3 flex items-center justify-between" data-id="element-54">
              <div className="flex items-center gap-2" data-id="element-55">
                <GiftIcon className="w-4 h-4 text-white" data-id="element-56" />
                <span className="text-white text-xs font-bold uppercase tracking-wider font-sans" data-id="element-57">
                  Bonus #2
                </span>
              </div>
              <div className="bg-white text-forest text-xs font-black uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-58">
                100% FREE
              </div>
            </div>
            {/* Scarcity ribbon */}
            <div className="bg-burnt/10 border-b border-burnt/20 px-6 py-2" data-id="element-59">
              <p className="font-sans text-burnt text-xs font-semibold text-center" data-id="element-60">
                ⚡ Only available for new customers ordering today
              </p>
            </div>

            <div className="p-6 md:p-8" data-id="element-61">
              {/* Product Image with Digital Edition seal */}
              <div className="relative w-56 sm:w-48 md:w-40 mx-auto mb-5" data-id="element-62">
                <div className="absolute -top-2 -right-2 z-20 bg-forest text-white rounded-full w-14 h-14 flex flex-col items-center justify-center shadow-lg border-2 border-white transform rotate-12" data-id="element-63">
                  <MonitorSmartphoneIcon className="w-3 h-3 mb-0.5" data-id="element-64" />
                  <span className="text-[7px] font-bold uppercase leading-tight text-center font-sans" data-id="element-65">
                    Digital
                    <br data-id="element-66" />
                    Edition
                  </span>
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/x15PhBqVyHqtAkGc3AF2Zv/411bf397-98dc-40be-a6ac-772985a1811b.png" alt="Direct Expert Link — Your Personal Garden Mentor" className="w-full h-auto rounded-lg shadow-md" data-id="element-67" />
              </div>

              <h3 className="font-serif text-forest text-xl md:text-2xl font-bold mb-2" data-id="element-68">
                Direct Expert Link: Your Personal Garden Mentor
              </h3>
              <p className="font-sans text-gray-500 text-sm leading-relaxed mb-4" data-id="element-69">
                Stuck? Confused about your specific plant? Get direct access to
                the creator of the Shield.
              </p>

              {/* Price — more prominent */}
              <div className="flex items-center gap-3 mb-4" data-id="element-70">
                <span className="font-sans text-gray-400 text-base line-through" data-id="element-71">
                  $54.00
                </span>
                <span className="bg-forest text-white text-sm font-black uppercase px-4 py-1.5 rounded-full tracking-wide flex items-center gap-1.5" data-id="element-72">
                  <SparklesIcon className="w-3.5 h-3.5" data-id="element-73" />
                  FREE TODAY
                </span>
              </div>

              <p className="font-sans text-gray-500 text-sm leading-relaxed mb-5 italic" data-id="element-74">
                "You are never alone. If you're not sure how to apply a protocol
                to your unique backyard, you get direct contact to ask
                questions. It's like having a pro landscaper in your pocket."
              </p>

              <ul className="space-y-2.5" data-id="element-75">
                <li className="flex items-start gap-2.5" data-id="element-76">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-77" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-78">
                    Personalized advice for your specific Zip Code
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-79">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-80" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-81">
                    Guidance on complex plant recovery
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-82">
                  <CheckIcon className="w-4 h-4 text-forest mt-0.5 flex-shrink-0" strokeWidth={2.5} data-id="element-83" />
                  <span className="font-sans text-gray-600 text-sm" data-id="element-84">
                    1-on-1 support to ensure your garden thrives
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}